import React from 'react';
import styled from 'App/styled';


const Loader = styled.div`
  display: flex;
  justify-content: center;
  .spin {
    border: 4px solid ${props => props.theme.brandPrimary};
    border-radius: 50%;
    border-top: 4px solid #f3f3f3;
    width: 30px;
    height: 30px;
    -webkit-animation: spin 2s linear infinite; /* Safari */
    animation: spin 2s linear infinite;
  }
  @-webkit-keyframes spin {
    0% {
      -webkit-transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
    }
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

const Spinner = () => (
  <Loader>
    <span className="spin" />
  </Loader>
);

export default Spinner;
